import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

import { SEARCH_PAGE_BREAKPOINTS } from "@/search/Langston/SearchPage/SearchPage.constants";

const { ui } = constants.colors;
const { mediaQuery: breakpoint } = mediaQueryStyles;

const UPPER_MARGIN = 150;

export const rootChipCss: CSSObject = {
  display: "block",
  minWidth: "40px",
  width: "fit-content",
  padding: "3px 8px",

  "& > label, & > div": {
    padding: 0,
    height: "24px",
    justifyContent: "center",
  },

  "& span": {
    fontSize: "14px",
  },

  [breakpoint.upTo(SEARCH_PAGE_BREAKPOINTS.MD)]: {
    padding: "7px 12px",
  },
};

export const getFilterPanelContainerCss = (isOpen: boolean): CSSObject => ({
  backgroundColor: ui.white[50],
  height: "fit-content",
  minWidth: "290px",
  maxWidth: "290px",
  borderBottomRightRadius: "16px",

  [breakpoint.upTo(SEARCH_PAGE_BREAKPOINTS.MD)]: {
    zIndex: 2,
    maxWidth: "inherit",
    minWidth: "inherit",
    width: "100%",
    borderRadius: isOpen ? "0 0 16px 16px" : "0",
    borderBottom: `1px solid ${constants.colors.ui.neutral[100]}`,
  },
});

export const getFilterPanelFiltersSectionVisibilityCss = (
  isOpen: boolean,
  windowHeight: number,
): CSSObject => ({
  display: "flex",
  flexDirection: "column",
  padding: "0 16px 16px 16px",
  borderBottomRightRadius: "16px",

  [breakpoint.upTo(SEARCH_PAGE_BREAKPOINTS.MD)]: {
    maxHeight: `${windowHeight - UPPER_MARGIN}px`,
    overflowY: "scroll",
    background: constants.colors.ui.white[25],
    display: isOpen ? "flex" : "none",
    borderRadius: isOpen ? "0 0 16px 16px" : "0",
  },
});
